import { render, staticRenderFns } from "./TaxDisclaimer.vue?vue&type=template&id=4ec64358&"
import script from "./TaxDisclaimer.vue?vue&type=script&lang=js&"
export * from "./TaxDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./TaxDisclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports